import { DifferenceProps } from '../DifferenceElementView';
import DifferenceDescription from '../DifferenceDescription/DifferenceDescription';
import AnnotationThumbnailIcon from '../../../icons/AnnotationThumbnailIcon/AnnotationThumbnailIcon';

const UnmatchedAnnotationDifference = ({ difference, multipleSelectionMode = false }: DifferenceProps) => {
  const parseUpdatedAt = (updatedAt: string) => {
    // Ensure input is a string
    if (typeof updatedAt !== 'string') return null;

    // Handle both UTC Z format and standard PDF format with timezone offset
    const match = updatedAt.match(/D:(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(?:Z|([+-])(\d{2})'(\d{2})')?/);
    if (!match) return null; // Handle invalid format

    const [, year, month, day, hour, minute, second, offsetSign, offsetHours, offsetMinutes] = match;

    if (!year || !month || !day || !hour || !minute) return null;

    // Create date in UTC first
    let date = new Date(
      Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second) || 0),
    );

    // Apply timezone offset if present
    if (offsetSign && offsetHours && offsetMinutes) {
      const offsetMillis = (Number(offsetHours) * 60 + Number(offsetMinutes)) * 60000;
      const millisToAdjust = offsetSign === '+' ? -offsetMillis : offsetMillis;
      date = new Date(date.getTime() + millisToAdjust);
    }

    if (isNaN(date.getTime())) return null; // Check if the date is valid

    const formattedDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    const formattedTime = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });

    return { formattedDate, formattedTime };
  };

  const updatedAt = String(difference.annotationDetail?.comments?.[0]?.updatedAt ?? '');
  const author = difference.annotationDetail?.comments[0]?.author || 'Unknown';
  const result = updatedAt ? parseUpdatedAt(updatedAt) : null;

  const differenceString = result ? `${author} | ${result.formattedDate} | ${result.formattedTime}` : `${author}`;

  return (
    <DifferenceDescription
      difference={difference}
      targetDescription={<AnnotationThumbnailIcon />}
      sourcePageNumberText={`source (p${difference.source.location.pageNumber})`}
      targetPageNumberText={`new (p${difference.target.location.pageNumber})`}
      showExtra={true}
      extraDescription={differenceString}
      multipleSelectionMode={multipleSelectionMode}
    />
  );
};

export default UnmatchedAnnotationDifference;
